import React, { FC } from 'react'

const ShieldSmallIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4833_3490)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C9.80535 2 7.31039 2.89881 5.50125 3.71258C4.33002 4.23941 3.74441 4.50283 3.34107 5.16332C2.93772 5.82381 2.97325 6.49255 3.0443 7.83004C3.24636 11.6339 3.99344 15.3705 6.39234 18.4491C7.57945 19.9726 10.0656 22 12 22C13.9344 22 16.4205 19.9726 17.6076 18.4491C20.0066 15.3705 20.7537 11.6339 20.9557 7.82996C21.0267 6.49252 21.0623 5.8238 20.6589 5.16332C20.2556 4.50285 19.67 4.23944 18.4988 3.71261C16.6896 2.89883 14.1947 2 12 2ZM16.5 9.48438C16.5 9.7363 16.4039 9.98822 16.2117 10.1804L11.6961 14.7117C11.5115 14.8963 11.2611 15 11 15C10.7389 15 10.4885 14.8963 10.3039 14.7117L8.28832 12.6961C8.09611 12.5038 8 12.2519 8 12C8 11.7481 8.09611 11.4962 8.28832 11.3039C8.67274 10.9195 9.29601 10.9195 9.68043 11.3039L11 12.6235L14.8196 8.78832C15.0118 8.59611 15.2637 8.5 15.5156 8.5C15.7675 8.5 16.0195 8.59611 16.2117 8.78832C16.4039 8.98053 16.5 9.23245 16.5 9.48438Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4833_3490">
        <rect width="24" height="24" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
)

export default ShieldSmallIcon
